enum RestartMachineConstants {
  CLOSE_RESTART_MACHINE_MODAL = '@RestartMachine/CLOSE_RESTART_MACHINE_MODAL',
  SHOW_RESTART_MACHINE_ERROR_BANNER = '@RestartMachine/SHOW_RESTART_MACHINE_ERROR_BANNER',
  DISMISS_RESTART_MACHINE_ERROR_BANNER = '@RestartMachine/DISMISS_RESTART_MACHINE_ERROR_BANNER',
  OPEN_RESTART_MACHINE_MODAL = '@RestartMachine/OPEN_RESTART_MACHINE_MODAL',
}

export default RestartMachineConstants;
